import { createFileRoute } from '@tanstack/react-router';

import { ClubWorkInviteInfoPage } from '@/features/work/pages/club-work-invite-info-page/ClubWorkInviteInfoPage';
import { redirectUnauthenticated } from '@/shared/helper/redirectUnauthenticated';

export const Route = createFileRoute(
  '/clubOwner/$id/work-invite/$workInviteId'
)({
  beforeLoad: ({ context }) => {
    redirectUnauthenticated(context);
  },
  component: ClubWorkInviteInfoPage
});
